import { render, staticRenderFns } from "./AssignDialog.vue?vue&type=template&id=62a3a59d&"
import script from "./AssignDialog.vue?vue&type=script&lang=js&"
export * from "./AssignDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports